import config from 'config'
import { readVariant, resolveRoute } from './helpers'

/**
 * Maps a variant letter straight to its route without touching the cookie.
 * Use it when the letter is already known, so the mapping stays reactive.
 */
export const routeForVariant = (variant: string | null): { name: string } => {
  return { name: resolveRoute(variant, config.abTest?.checkout || {}) }
}

/**
 * The one place that turns a variant letter into a checkout route.
 * Every entry point into a checkout must go through here.
 */
export const getCheckoutRoute = (): { name: string } => {
  return routeForVariant(readVariant())
}

/**
 * The first configured route, without reading the cookie. Components use this
 * as their initial value so the server and the client agree, then swap to
 * getCheckoutRoute() after mount.
 */
export const defaultCheckoutRoute = (): { name: string } => {
  return routeForVariant(null)
}
